exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-644fd6e0]{margin-top:13px}.audio-wrap[data-v-644fd6e0]{padding:8px 10px 11px 14px;width:500px;height:60px;border:1px solid #ddd}.video-wrap[data-v-644fd6e0]{width:406px;height:228px;position:relative}", ""]);

// exports
